// @ts-nocheck
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<GetShipmentsApiParameter>;

export const DispatchSetParameter: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/ShipmentHistory/SetParameter",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetParameter];

const setParameter = createHandlerChainRunner(chain, "SetParameter");
export default setParameter;
